package ai.wagemix.net.client

import ai.wagemix.net.models.WMJDUrlUpload
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.replacePathParams

class WMJobDescriptionUrlUploadRequestBuilder: WMEventStreamReferencingRequestBuilder<
        WMJobDescriptionUrlUploadRequestBuilder,
        WMJDUrlUpload
>() {
    override fun build(): FSRequest<WMJDUrlUpload> {
        method(FSRequest.Method.Post)
        contentTypeJson()
        replacePathParams("api", "v1", "upload-jd-url")
        return super.build()
    }

    override fun self(): WMJobDescriptionUrlUploadRequestBuilder = this
}